import classNames from 'classnames';
import {
  inject, observer,
} from 'mobx-react';
import React, {
  Component,
} from 'react';
import * as Yup from 'yup';
import AlertDialog from '../../components/Dialog/alertDialog';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  IForgotPasswordStore,
} from '../../mobx-store/storeInterfaces/forgotPasswordInterface';
import classes from './forgotPassword.module.scss';

interface IProps {
  forgotPasswordStore: IForgotPasswordStore;
  history: any;
}

interface IState {
  formFields: FormField[];
  open: boolean;
}

@inject('forgotPasswordStore')
@observer
class ForgotPassword extends Component<IProps, IState> {
  emailSuffix = '@wadidegla.com';

  forgotPasswordSchema: any;

  submitButton: any;

  constructor(props: IProps) {
    super(props);
    this.initForgotPasswordSchema();
    this.initState();
    this.submitButton = this.getSubmitButton();
  }

  initState = () => {
    this.state = {
      open: false,
      formFields: [
        {
          name: 'email',
          label: 'Email',
          type: 'text',
          filedType: 'InputField',
          suffix: this.emailSuffix,
        },
      ],
    };
  };

  initForgotPasswordSchema() {
    this.forgotPasswordSchema = Yup.object().shape({
      email: Yup.string().required('Required'),
    });
  }

  handleSubmit = (values: any): void => {
    console.log(values);
    const email = `${values.email}${this.emailSuffix}`;
    this.handleClickOpen();
    this.props.forgotPasswordStore.handleForgotPasswordEmail(email);
  };

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
    this.props.history.goBack();
  };

  getSubmitButton = () => ({
    title: 'Send',
    onSubmit: this.handleSubmit,
  });

  render() {
    return (
      <div className={classNames(classes.forgotPasswordPage)}>
        <div>
          <p>
            {translate('loginScreen.forgotPasswordEnterEmailMessage', {
            })}
          </p>
        </div>
        <div>
          <GeneralFormComponent
            fields={this.state.formFields}
            formTitle=""
            formSchema={this.forgotPasswordSchema}
            submitButton={this.submitButton}
            processing={false}
          />
        </div>
        <div>
          <AlertDialog
            title="Wadi Degla Dashboard"
            content={translate('loginScreen.emailSentSuccessMessage', {
            })}
            isOpen={this.state.open}
            buttonText="ok"
            handleClose={this.handleClose}
          />
        </div>
      </div>
    );
  }
}

export default ForgotPassword;
